/*
 * Copyright (c) 2018-2022. AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { default as React, useEffect, useRef } from "react";
import ReactTooltip from "react-tooltip";
import { default as classNames } from "classnames";
import { default as Styles } from "./InputLabel.module.scss";
import { t } from "../../../utils/i18n/i18n";

interface Props {
  text: string;
  tooltip?: string;
  isTooltipDisplayed?: boolean | null;
  isError?: boolean;
  isRequired?: boolean;
}

const InputLabel = ({ text, tooltip, isTooltipDisplayed, isError = false, isRequired = true }: Props) => {
  const tooltipRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (tooltipRef && tooltipRef.current) {
      if (!!isTooltipDisplayed) {
        ReactTooltip.show(tooltipRef.current);
      } else {
        ReactTooltip.hide(tooltipRef.current);
      }
    }
  }, [isTooltipDisplayed]);
  return (
    <label className={classNames(Styles.inputLabelContainer, { [Styles.error]: isError })}>
      {text} {!isRequired && t("RegisterPage.optionalPoliciesOptional")}{" "}
      {tooltip && <i className="icon-ab-info" data-tip={tooltip} ref={tooltipRef} />}
      <ReactTooltip />
    </label>
  );
};

export default InputLabel;
